module.exports = __webpack_public_path__ + "img/pre.f4ed5ab5.png";